/**
 * Agents — non-admin routes scoped by `organization_id` query.
 *
 * Backend authorizes platform-admin as internal (bypasses membership), so these
 * work from the admin UI. There is no admin-only variant and no DELETE route.
 */
import { apiGet, apiPatch, apiPost } from '../client.js';
import type { Agent, CreateAgentBody, UpdateAgentBody } from '../types.js';

export interface ListAgentsFilters {
  organization_id: string;
  limit?: number;
  offset?: number;
}

export function listAgents(filters: ListAgentsFilters): Promise<Agent[]> {
  return apiGet<Agent[]>('/api/v1/agents', {
    organization_id: filters.organization_id,
    limit: filters.limit,
    offset: filters.offset,
  });
}

export function getAgent(id: string): Promise<Agent> {
  return apiGet<Agent>(`/api/v1/agents/${id}`);
}

export function createAgent(body: CreateAgentBody): Promise<Agent> {
  return apiPost<Agent>('/api/v1/agents', body);
}

export function updateAgent(id: string, body: UpdateAgentBody): Promise<Agent> {
  return apiPatch<Agent>(`/api/v1/agents/${id}`, body);
}
